// ISSUE-0039: consumer-side feedback context capture. Small self-contained breadcrumb ring buffer
// + page/timing capture; no new server instrumentation (richer logging is ISSUE-0064 / ISSUE-0034).

export interface Breadcrumb {
  ts: string;
  kind: 'nav' | 'error' | 'action';
  message: string;
}

const MAX = 15;
const buffer: Breadcrumb[] = [];

export function recordBreadcrumb(kind: Breadcrumb['kind'], message: string): void {
  buffer.push({ ts: new Date().toISOString(), kind, message: String(message).slice(0, 200) });
  while (buffer.length > MAX) buffer.shift();
}

export function getBreadcrumbs(): Breadcrumb[] {
  return buffer.slice();
}

export function clearBreadcrumbs(): void {
  buffer.length = 0;
}

let installed = false;
export function installBreadcrumbListeners(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  window.addEventListener('error', (e) => recordBreadcrumb('error', e.message || 'window error'));
  window.addEventListener('unhandledrejection', (e) =>
    recordBreadcrumb('error', String((e as PromiseRejectionEvent).reason ?? 'unhandled rejection')),
  );
}

function collectEnv(): Record<string, unknown> {
  let loadMs: number | null = null;
  try {
    const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
    if (nav) loadMs = Math.round(nav.loadEventEnd - nav.startTime) || null;
  } catch {
    /* timing unavailable */
  }
  return {
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    language: typeof navigator !== 'undefined' ? navigator.language : '',
    viewport: typeof window !== 'undefined' ? `${window.innerWidth}x${window.innerHeight}` : null,
    loadMs,
  };
}

export function buildConsumerFeedbackContext(adviceJobId: string): Record<string, unknown> {
  const loc = typeof window !== 'undefined' ? window.location : ({ pathname: '', search: '' } as Location);
  return {
    capturedAt: new Date().toISOString(),
    surface: 'consumer',
    page: { route: `${loc.pathname}${loc.search}` },
    job: { adviceJobId },
    env: collectEnv(),
    breadcrumbs: getBreadcrumbs(),
  };
}
